<template>
  <div>
    <vx-breadcrumb :list="breadcrumbList" class="custom-bread-crumb" />
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5 mt-3">
        <li>
          <div @click="cancelEdit" class="vx-row cursor-pointer">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("View Customer Ticket") }}</h4>
          </div>
        </li>
      </ul>
    </div>
      <vx-card>
        <form>
          <div class="vx-row">
            <div class="vx-col w-2/3">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <div class="pb-5">
                      <vs-input
                        label="Category"
                        v-model="ticket.problemCode"
                        class="min-w-200 w-full mb-2"
                        disabled="true"
                      />
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="pb-5">
                      <vs-input
                        label="Sub Category"
                        v-model="ticket.subCategory"
                        class="min-w-200 w-full mb-2"
                        disabled="true"
                      />
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="pb-5">
                      <vs-input
                        :label="$t('customers.label.priority')"
                        v-model="ticket.priority"
                        class="w-full font-semibold mb-2"
                        icon-no-border
                        :danger="false"
                        danger-text="wrong input"
                        disabled="true"
                      />
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="pb-5">
                  <vs-input
                    :label="$t('customers.label.ticket_date')"
                    class="w-full font-semibold"
                    readonly
                    v-model="ticket.ticketDate"
                    disabled="true"
                  />
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="pb-5">
                    <vs-input
                      label="Source"
                      class="min-w-200 w-full mb-2"
                      v-model="ticket.sourceOfTicket"
                      disabled="true"
                    />
                  </div>
                </div>
                <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                  <div class="pb-5">
                    <vs-input
                      label="Due Time"
                      class="w-full"
                      disabled="true"
                      v-model="ticket.strTicketDate"
                    />
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="pb-5">
                      <vs-input
                        label="Team"
                        v-model="ticket.teamCode"
                        class="min-w-200 w-full mb-2"
                        disabled="true"
                      />
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="pb-5">
                      <vs-input
                        label="Team User"
                        v-model="ticket.assignedTo"
                        class="min-w-200 w-full mb-2"
                        disabled="true"
                      />
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col w-1/3">
              <div class="view-container">
                <div class="pb-2 font-semibold flex justify-between">
                  <span> {{ $t("customers.label.TicketHistory") }}</span>
                  <feather-icon
                    v-if="
                      ticketById.attachments &&
                      ticketById.attachments[0].fileName &&
                      ticketById.attachments[0].fileName !== 'null'
                    "
                    title="Download Uploaded File"
                    icon="DownloadIcon"
                    @click.stop="downloadFile(ticketById.id)"
                    class="icon_row mr-1 text-success ml-auto"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  />
                </div>
                <div
                  class="text-sm ticket-el"
                  v-if="ticketDetailsById && ticketDetailsById.id"
                >
                  <vx-card
                    class="mt-3 mb-3 history-card"
                    :class="getCardStatusClass(ticketDetailsById.status)"
                  >
                    <div class="vx-row w-full detail-text">
                      <div class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.id") }}</b>
                      </div>
                      <div class="vx-col md:w-1/2">
                        {{ ticketDetailsById.id }}
                      </div>
                      <div class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.user") }}</b>
                      </div>
                      <div class="vx-col md:w-1/2">
                        {{ ticketDetailsById.createdByUsername }}
                      </div>
                      <div class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.created_date") }}</b>
                      </div>
                      <div class="vx-col md:w-1/2">
                        {{ getDate2(ticketDetailsById.strTicketDate) }}
                      </div>
                      <div
                        v-if="ticketDetailsById.strTicketDate"
                        class="vx-col md:w-1/2"
                      >
                        <b>{{ $t("customers.label.created_time") }}</b>
                      </div>
                      <div
                        v-if="ticketDetailsById.strTicketDate"
                        class="vx-col md:w-1/2"
                      >
                        {{ getTime(ticketDetailsById.strTicketDate) }}
                      </div>
                      <div class="vx-col md:w-1/2">
                        <b>{{ $t("SLA Time") }}</b>
                      </div>
                      <div class="vx-col md:w-1/2">
                        {{ ticketDetailsById.etaResponse }}
                      </div>
                      <div class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.description") }}</b>
                      </div>
                      <div class="vx-col md:w-1/2">
                        {{ ticketDetailsById.description }}
                      </div>
                    </div>
                  </vx-card>
                </div>
                <div
                  class="text-sm ticket-el"
                  v-for="(item, index) in ticketViewById"
                  :key="index"
                >
                  <vx-card
                    class="mt-3 mb-3 history-card"
                    :class="getCardStatusClass(item.status)"
                  >
                    <div class="vx-row w-full detail-text">
                      <div v-if="item.assignedTo" class="vx-col md:w-1/2">
                        <b>{{ $t("leads.label.assigned_to") }}</b>
                      </div>
                      <div v-if="item.assignedTo" class="vx-col md:w-1/2">
                        {{ item.assignedTo }}
                      </div>

                      <div
                        v-if="item.strTicketDate && item.resolutionDescription"
                        class="vx-col md:w-1/2"
                      >
                        <b>{{ $t("customers.label.resolution_date") }}</b>
                      </div>
                      <div v-else class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.created_date") }}</b>
                      </div>
                      <div class="vx-col md:w-1/2">
                        {{ getDate2(item.strTicketDate) }}
                      </div>

                      <div v-if="item.strTicketDate" class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.created_time") }}</b>
                      </div>
                      <div v-if="item.strTicketDate" class="vx-col md:w-1/2">
                        {{ getTime(item.strTicketDate) }}
                      </div>
                      <div v-if="item.status" class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.status") }}</b>
                      </div>
                      <div v-if="item.status" class="vx-col md:w-1/2">
                        {{ item.status }}
                      </div>
                      <div v-if="item.lastComment" class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.last_comment") }}</b>
                      </div>
                      <div v-if="item.lastComment" class="vx-col md:w-1/2">
                        {{ item.lastComment }}
                      </div>

                      <div
                        v-if="item.resolutionDescription"
                        class="vx-col md:w-1/2"
                      >
                        <b>{{
                          $t("customers.label.resolution_description")
                        }}</b>
                      </div>
                      <div
                        v-if="item.resolutionDescription"
                        class="vx-col md:w-1/2"
                      >
                        {{ item.resolutionDescription }}
                      </div>
                    </div>
                  </vx-card>
                </div>
              </div>
            </div>
          </div>
        </form>
      </vx-card>
      <div style="margin-top: 5px"></div>
      <vx-card>
        <form>
          <div>
            <div class="flex items-center mt-4 mb-2 bold">
              <h3>Feedback From</h3>
            </div>
            <div class="flex items-center mt-5">
              <vs-button
                v-if="selfcareFeedback"
                color="primary"
                @click="openFeedback(selfcareFeedback.url)"
              >
                {{ selfcareFeedback.feedbackType }}
              </vs-button>
              <vs-button
                class="ml-2"
                v-if="crmFeedback"
                color="success"
                @click="openFeedback(crmFeedback.url)"
              >
                {{ crmFeedback.feedbackType }}
              </vs-button>
            </div>
          </div>
        </form>
      </vx-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";

const ticketObj = {
  strTicketDate: null,
  assignedTo: null,
  // reference: null,
  // referenceId: null,
  priority: null,
  sourceOfTicket: null,
  problemCode: null,
  problemDescription: null,
  subCategory: null,
  description: null,
  comment: null,
  teamCode: "",
  status: "OPEN",
  title: "",
  type: "Customer",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  ticketDate: moment().format("DD MM YYYY HH:mm:ss"),
  ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
  ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
  ticketTime: moment().format("HH:mm:ss A"),
};

export default {
  props: {
    feedback: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      breadcrumbList: [
        { name: "Customers", path: "/customers" },
        {
          name: "View Customer",
          path: `/customers/view_customer/${this.$route.params.id}`,
        },
        {
          name: "Customer View Ticket",
        },
      ],
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      resetKey: 0,
      ticket: { ...ticketObj },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d m Y H:i:S",
      },
      categoryId: null,
    };
  },
  components: {
  },
  computed: {
    ...mapState({
      ticketTemplates: (state) => state.entity.ticketTemplate,
      ticketById: (state) => state.customerTicket.ticketById,
      subCategoryItem: (state) => state.entity.ticketSubcategory,
      teamUsers: (state) => state.customer.teamUsers,
      ticketViewById: (state) => state.customerTicket.ticketViewById,
      ticketDocumentData: (state) => state.customerTicket.ticketDocumentData,
      ticketDetailsById: (state) => state.customerTicket.ticketDetailsById,
      formattedDate: (state) => state.settings.selectedDateFormat,
      ticketFromStore: (state) => state.customerTicket.ticketViewDataById,
      feedback: (state) => state.customerTicket.ticketViewDataById.feedback
    }),
    selfcareFeedback() {
      return this.feedback.find(f => f.feedbackType === "selfcare-User") || null;
    },
    crmFeedback() {
      return this.feedback.find(f => f.feedbackType === "CRM-User") || null;
    }
  },
  methods: {
    async getByIdticket() {
      try {
        await this.$store.dispatch("customerTicket/setViewTicketById",
          this.$route.params.ticketId,
        );
      } catch (error) {
        this.$toasted.error("something went wrong!");
      }
    },
    openFeedback(url) {
      window.open(url, "_blank");
    },
    getTime(time) {
      return time.split(" ")[1];
    },
    downloadFile(ticketId) {
      window.open(BUCKET_BASE_URL + `/tickets/${ticketId}/print`);
    },
    async getUserByTeam() {
      this.ticket.assignedTo = null;
      try {
        this.$store.dispatch("customer/getUserByTeam", this.ticket.teamCode);
      } catch (error) {
        throw Error(
          error.message ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    cancelEdit() {
      if (this.$route.query.type == "customer") {
        this.$router.push("/customer_tickets");
      } else if (this.$route.query.type == "entity") {
        this.$router.push("/entity_tickets");
      } else {
        this.$router.push({
          path: `/customers/view_customer/${this.$route.params.id}`,
          query: { activePage: 5 },
        });
      }
    },
    async getSubCategory(categoryId) {
      this.ticket.subCategory = null;
      try {
        if (categoryId) {
          this.$store.dispatch("entity/setTicketSubcategory", categoryId);
        } else {
          this.$store.commit("entity/SET_TICKET_SUBCATEGORY", []);
          this.ticket.subCategory = null;
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    dateFormat(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    getDate2(date) {
      const d = moment(date, "DD-MM-YYYY");
      const formattedDate = d.format(this.formattedDate);
      return formattedDate;
    },
    timeFormat(date) {
      return moment(date).format("HH:mm:ss");
    },
    async getTicketById() {
      try {
        this.$store.dispatch(
          "customerTicket/setsTicketById",
          this.$route.params.ticketId
        );
        await this.$store.dispatch(
          "customerTicket/getTicketDetailsByIdAction",
          {
            id: this.$route.params.ticketId,
          }
        );

        await this.getSubCategory(this.ticketDetailsById.problemCode);

        const TicketDate = moment(
          this.ticketDetailsById.strTicketDate,
          "DD-MM-YYYY HH:mm:ss"
        ).format("DD MM YYYY HH:mm:ss");

        this.ticket.assignedTo = this.ticketDetailsById.teamUserId;
        this.ticket.priority = this.ticketDetailsById.priority;
        this.ticket.problemCode = this.ticketDetailsById.problemCode;
        this.ticket.subCategory = this.ticketDetailsById.subCategorys;
        this.ticket.ticketDate = TicketDate;
        this.ticket.status = this.ticketDetailsById.status;
        this.ticket.strTicketDate = this.ticketDetailsById.strDueDate;
        this.ticket.description = this.ticketDetailsById.description;
        this.ticket.sourceOfTicket = this.ticketDetailsById.sourceOfTicket;
        this.ticket.teamCode = Number(this.ticketDetailsById.teamCode);

        await this.$store.dispatch(
          "customer/getUserByTeam",
          this.ticket.teamCode
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    getStatusClass(status) {
      switch (status) {
        case "OPEN":
          return "text-blue";
        case "REOPEN":
          return "text-yellow";
        case "CLOSED":
          return "text-green";
        case "Escalated":
          return "text-red";
        default:
          return "text-gray";
      }
    },
    getCardStatusClass(status) {
      switch (status) {
        case "OPEN":
          return "border-blue";
        case "REOPEN":
          return "border-yellow";
        case "CLOSED":
          return "border-green";
        case "Escalated":
          return "border-red";
        default:
          return "border-gray";
      }
    },
    getPriorityClass(priority) {
      switch (priority) {
        case "HIGH":
          return "high-priority";
        case "MEDIUM":
          return "medium-priority";
        case "LOW":
          return "low-priority";
        default:
          return "";
      }
    },
  },
  watch: {
    feedback: {
    handler(newVal) {
      if (newVal && newVal.length > 0) {
        console.log("Now feedback arrived:", newVal);
      }
    },
    deep: true,
    immediate: true
  }
  },
  async mounted() {
    await this.getTicketById();
    this.id = this.$route.params.ticketId;
    await this.getByIdticket();
  },
};
</script>

<style scoped>
.flatpickr-calendar.open {
  z-index: 999999999999;
}
.ticket-el {
  border-top: 1px solid #ccc;
}
.view-container {
  background: #eee;
  height: 24rem;
  overflow-y: scroll;
  padding: 10px;
  border-radius: 8px;
}
.high-priority {
  color: red;
}

.medium-priority {
  color: orange;
}

.low-priority {
  color: green;
}
.text-blue {
  color: blue;
}
.text-yellow {
  color: rgb(224, 224, 27);
}
.text-red {
  color: red;
}
.text-green {
  color: green;
}
.text-gray {
  color: gray;
}
.border-blue {
  border: 2px solid blue;
  background-color: rgb(180, 180, 255);
}
.border-yellow {
  border: 2px solid rgb(224, 224, 27);
  background-color: rgb(255, 255, 200);
}
.border-red {
  border: 2px solid red;
  background-color: rgb(255, 177, 177);
}
.border-green {
  border: 2px solid green;
  background-color: rgb(200, 255, 200);
}
.border-gray {
  border: 2px solid gray;
}
.history-card ::v-deep .vx-card__body {
  padding: 12px !important;
}
</style>
